import { render, staticRenderFns } from "./AiBot.vue?vue&type=template&id=a5684c94&scoped=true"
import script from "./AiBot.vue?vue&type=script&lang=js"
export * from "./AiBot.vue?vue&type=script&lang=js"
import style0 from "./AiBot.vue?vue&type=style&index=0&id=a5684c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5684c94",
  null
  
)

export default component.exports